{
  "comment": "M10 P4b2d (plan docs/plans/2026-10-15-m10-p4b.md; spec \u00a74.5, \u00a76.5): operator kit part mounts, written by tools/blender/greybox_m10_kits.py. One part GLB per operator set; per kit its base hulls (ships.json def ids; pendingHulls have no def or model yet) and per part (the CON_ socket on the set GLB) and hull its mounts: a hull socket name or an origin offset in the hull asset space, mirror (add the port copy, x -> -x) and a uniform scale. P4b4a folds this into src/data/kits.json.",
  "sets": {
    "mutual": {
      "asset": "ship.kit_mutual_block",
      "kits": {
        "lifeline": {
          "hulls": [
            "hauler"
          ],
          "pendingHulls": [
            "meridian_tyne"
          ],
          "parts": [
            {
              "con": "CON_LIFELINE_POD",
              "face": "flank",
              "mounts": {
                "hauler": [
                  {
                    "offset": [
                      4.55,
                      -0.3,
                      0.2
                    ],
                    "mirror": true,
                    "scale": 0.99
                  }
                ]
              }
            }
          ]
        },
        "pickup": {
          "hulls": [
            "hauler",
            "miner"
          ],
          "pendingHulls": [],
          "parts": [
            {
              "con": "CON_PICKUP_CLAW_RACK",
              "face": "ventral",
              "mounts": {
                "hauler": [
                  {
                    "offset": [
                      0.0,
                      -4.0,
                      0.2
                    ],
                    "mirror": false,
                    "scale": 1.11
                  }
                ],
                "miner": [
                  {
                    "offset": [
                      0.0,
                      -3.05,
                      -1.45
                    ],
                    "mirror": false,
                    "scale": 0.88
                  }
                ]
              }
            }
          ]
        },
        "homestead": {
          "hulls": [
            "kestrel",
            "hauler",
            "hauler_large"
          ],
          "pendingHulls": [],
          "parts": [
            {
              "con": "CON_HOMESTEAD_HAB_POD",
              "face": "dorsal",
              "mounts": {
                "kestrel": [
                  {
                    "offset": [
                      0.0,
                      2.911,
                      -0.333
                    ],
                    "mirror": false,
                    "scale": 0.35
                  }
                ],
                "hauler": [
                  {
                    "offset": [
                      0.0,
                      3.4,
                      0.2
                    ],
                    "mirror": false,
                    "scale": 1.11
                  }
                ],
                "hauler_large": [
                  {
                    "offset": [
                      0.0,
                      15.0,
                      -0.05
                    ],
                    "mirror": false,
                    "scale": 4.75
                  }
                ]
              }
            }
          ]
        },
        "neighbour": {
          "hulls": [
            "interceptor",
            "gunship"
          ],
          "pendingHulls": [],
          "parts": [
            {
              "con": "CON_NEIGHBOUR_STRAP_ON",
              "face": "flank",
              "mounts": {
                "interceptor": [
                  {
                    "offset": [
                      4.6,
                      0.445,
                      -0.15
                    ],
                    "mirror": true,
                    "scale": 0.96
                  }
                ],
                "gunship": [
                  {
                    "offset": [
                      6.401,
                      0.775,
                      -0.06
                    ],
                    "mirror": true,
                    "scale": 1.68
                  }
                ]
              }
            }
          ]
        }
      }
    },
    "wreckers": {
      "asset": "ship.kit_wreckers_block",
      "kits": {
        "ram": {
          "hulls": [
            "miner"
          ],
          "pendingHulls": [],
          "parts": [
            {
              "con": "CON_RAM_PLATE",
              "face": "bow",
              "mounts": {
                "miner": [
                  {
                    "offset": [
                      0.0,
                      2.175,
                      -19.0
                    ],
                    "mirror": false,
                    "scale": 1.0
                  }
                ]
              }
            }
          ]
        },
        "runner": {
          "hulls": [
            "meridian_courier"
          ],
          "pendingHulls": [],
          "parts": [
            {
              "con": "CON_RUNNER_PANEL",
              "face": "flank",
              "mounts": {
                "meridian_courier": [
                  {
                    "offset": [
                      5.5,
                      0.6,
                      -0.55
                    ],
                    "mirror": true,
                    "scale": 0.99
                  }
                ]
              }
            }
          ]
        },
        "stripper": {
          "hulls": [
            "salvager",
            "hauler"
          ],
          "pendingHulls": [],
          "parts": [
            {
              "con": "CON_STRIPPER_RACK",
              "face": "dorsal",
              "mounts": {
                "salvager": [
                  {
                    "offset": [
                      0.0,
                      4.0,
                      -0.95
                    ],
                    "mirror": false,
                    "scale": 0.86
                  }
                ],
                "hauler": [
                  {
                    "offset": [
                      0.0,
                      3.4,
                      0.2
                    ],
                    "mirror": false,
                    "scale": 1.27
                  }
                ]
              }
            }
          ]
        },
        "prize": {
          "hulls": [],
          "pendingHulls": [
            "meridian_tyne"
          ],
          "parts": [
            {
              "con": "CON_PRIZE_CLAMP",
              "face": "bow",
              "mounts": {}
            }
          ]
        },
        "harpoon": {
          "hulls": [
            "gunship"
          ],
          "pendingHulls": [],
          "parts": [
            {
              "con": "CON_HARPOON_SLED",
              "face": "flank",
              "mounts": {
                "gunship": [
                  {
                    "offset": [
                      6.401,
                      0.775,
                      -0.06
                    ],
                    "mirror": true,
                    "scale": 1.01
                  }
                ]
              }
            }
          ]
        }
      }
    }
  }
}
